export default __webpack_public_path__ + "static/media/instagram-brands.23eb42bc.svg";